import type { IncomingMessage } from 'http';
import { Language } from '@peloton/internationalize/models/language';

const PAGES_REGEX = /^((?:\w|-)*)--members-onepeloton-com\.pages\.dev/;
const LEGACY_NETLIFY_REGEX = /^((?:\w|-)*)--uat-members-onepeloton-com\.pages\.dev/;
const PRIVATE_UAT_REGEX = /^((?:\w|-)*)-members--test-onepeloton-com\.pages\.dev/;
const UAT_HOST = 'members.uat.onepeloton.com';
const LEGACY_UAT_HOST = 'uat-members.onepeloton.com';
const PRIVATE_UAT_HOST = 'members.test.onepeloton.com';
const PROTOCOL_REGEX = /^https?:\/\//;

const toHostFromMatches = (matches: RegExpExecArray, host: string) => {
  if (matches[1] !== 'main') {
    return [matches[1], host].join('--');
  } else {
    return host;
  }
};

const withProtocol = (host: string) =>
  PROTOCOL_REGEX.test(host) ? host : `https://${host}`;

const toPeloDeployPreview = (host: string) => {
  const matches = PAGES_REGEX.exec(host);
  const legacyMatches = LEGACY_NETLIFY_REGEX.exec(host);
  const privateUatMatches = PRIVATE_UAT_REGEX.exec(host);
  if (matches !== null) {
    return toHostFromMatches(matches, UAT_HOST);
  } else if (legacyMatches !== null) {
    return toHostFromMatches(legacyMatches, LEGACY_UAT_HOST);
  } else if (privateUatMatches !== null) {
    return toHostFromMatches(privateUatMatches, PRIVATE_UAT_HOST);
  }

  return host;
};

const toUrlString = (host: string) => withProtocol(toPeloDeployPreview(host));

export const toUrlFromHostHeader = (fallback: URL, { headers }: IncomingMessage): URL => {
  try {
    const host = headers?.host;
    const xfp = headers?.['x-forwarded-proto'];
    const xfh = headers?.['x-forwarded-host'];
    if (xfp && xfh) {
      return new URL(`${xfp}://${xfh}`);
    } else if (host) {
      return new URL(toUrlString(host));
    }
  } catch {
    // TODO: quietly report this to Sentry?
  }
  return fallback;
};

export const toLanguageFromHostname = ({ headers }: IncomingMessage): Language => {
  const host = headers?.host ?? '';
  const lang = /\.de$/.test(host) ? Language.German : Language.English;
  return lang;
};
